module.exports = __webpack_public_path__ + "img/GAMA-logo.99d1f566.png";